import { motion } from "framer-motion";
import { Star, Quotes } from "@phosphor-icons/react";

const testimonials = [
  {
    quote:
      "Desde que a Kordeiro assumiu a nossa TI, o sistema da clínica não caiu mais. O atendimento é rápido e tudo ficou documentado.",
    name: "Dra. Renata M.",
    role: "Clínica — Rio de Janeiro",
    testid: "testimonial-card-1",
  },
  {
    quote:
      "O Wi-Fi do restaurante vivia caindo no horário de pico. Hoje funciona perfeitamente e ainda organizaram todo o nosso inventário de equipamentos.",
    name: "Marcelo S.",
    role: "Restaurante — Rio de Janeiro",
    testid: "testimonial-card-2",
  },
  {
    quote:
      "Finalmente temos processos de TI claros. O suporte proativo resolve antes de virar problema — é outro nível de tranquilidade.",
    name: "Fernanda L.",
    role: "Escritório — Rio de Janeiro",
    testid: "testimonial-card-3",
  },
];

export default function Testimonials() {
  return (
    <section id="depoimentos" data-testid="testimonials-section" className="py-24 lg:py-32 bg-[#FAFAFA] border-t border-black/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="mb-16 lg:mb-20 max-w-2xl"
        >
          <p data-testid="testimonials-eyebrow" className="text-xs font-semibold tracking-[0.3em] uppercase text-gold-dark mb-6">
            Depoimentos
          </p>
          <h2 className="font-display font-black tracking-tighter text-4xl sm:text-5xl lg:text-6xl text-ink leading-[1.02]">
            Quem confia,
            <span className="block text-gold-dark">recomenda.</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {testimonials.map((t, i) => (
            <motion.figure
              key={t.testid}
              data-testid={t.testid}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              className="group relative bg-white border border-black/5 rounded-sm p-8 lg:p-10 flex flex-col justify-between transition-all duration-500 hover:-translate-y-1 hover:border-gold/60"
            >
              <div>
                <div className="flex items-center justify-between mb-8">
                  <span className="flex gap-1" data-testid={`${t.testid}-stars`} aria-label="5 estrelas">
                    {[...Array(5)].map((_, s) => (
                      <Star key={s} size={16} weight="fill" className="text-gold" />
                    ))}
                  </span>
                  <Quotes size={32} weight="duotone" className="text-gold/30 transition-colors duration-500 group-hover:text-gold/60" />
                </div>
                <blockquote className="text-base text-neutral-700 leading-relaxed">
                  “{t.quote}”
                </blockquote>
              </div>
              <figcaption className="mt-10 pt-6 border-t border-black/5">
                <p className="font-display font-extrabold tracking-tight text-ink">{t.name}</p>
                <p className="text-xs text-neutral-500 tracking-wide mt-1">{t.role}</p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
